import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';
import Banner from '@zenbusiness/zui/Banner';
import SharedAsset from '@zenbusiness/zui/SharedAsset';

import { BANKING_UI_MAINTENANCE_BANNER } from '#client/constants/experimentsFlags';
import { BannerWrapperStyled } from '#client/pages/SharedStyles';

export default function ServerDrivenBanner() {
  const { icon, message, title } = useExperimentFlag(BANKING_UI_MAINTENANCE_BANNER, {}) || {};

  if (!icon || !message || !title) {
    return null;
  }

  return (
    <BannerWrapperStyled>
      <Banner
        slots={{
          startIcon: (
            <SharedAsset
              alt=""
              src={icon}
            />
          )
        }}
        subtitle={message}
        title={title}
      />
    </BannerWrapperStyled>
  );
}
